import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { CampanhaClienteVisualizacaoModoModule } from '../visualizacao-modo';
import { ClienteCadastroMultiselectModule } from '../../../../pessoa/cliente/cadastro/multiselect';
import { ClienteSituacaoMultiselectModule } from '../../../../pessoa/cliente/situacao/multiselect';
import { ClassificacaoTipoMultiselectModule } from '../../../../classificacao/tipo/multiselect';
import { RepresentanteMultiselectModule } from '../../../../pessoa/representante/multiselect';

import { CampanhaClienteFilterComponent } from './campanha-cliente-filter.component';

@NgModule({
    imports: [
        SharedModule,
        CampanhaClienteVisualizacaoModoModule,
        ClienteCadastroMultiselectModule,
        ClienteSituacaoMultiselectModule,
        ClassificacaoTipoMultiselectModule,
        RepresentanteMultiselectModule
    ],
    declarations: [
        CampanhaClienteFilterComponent
    ],
    exports: [
        CampanhaClienteFilterComponent
    ]
})
export class CampanhaClienteFilterModule { }
